import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import { useEffect } from 'react';
import type { CalendarEvent } from '@/app/(marketing-site)/bezplatna-konsultacja/_components/CalendarEvent';
import { useTRPC } from '@/app/api/trpc/config';
type UseSeedSelectedEventsMapWithEventsAvailableForBookingProps = {
  setAvailableForBookingEventsMap: (map: Map<string, CalendarEvent[]>) => void;
};
export function useSeedSelectedEventsMapWithEventsAvailableForBooking(t0) {
  const $ = _c(10);
  const {
    setAvailableForBookingEventsMap
  } = t0;
  const trpc = useTRPC();
  let t1;
  if ($[0] !== trpc.phoneCallBooking.getEventsAvailableForBooking) {
    t1 = trpc.phoneCallBooking.getEventsAvailableForBooking.queryOptions();
    $[0] = trpc.phoneCallBooking.getEventsAvailableForBooking;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getEventsAvailableForBookingQuery = useQuery(t1);
  let t2;
  if ($[2] !== getEventsAvailableForBookingQuery.data?.events || $[3] !== setAvailableForBookingEventsMap) {
    t2 = () => {
      const newMap = new Map();
      for (const event of getEventsAvailableForBookingQuery.data?.events ?? []) {
        newMap.set(format(event.startTime, "yyyy.MM.dd"), [...(newMap.get(format(event.startTime, "yyyy.MM.dd")) ?? []), {
          startTime: event.startTime,
          id: event.scheduleId
        }]);
      }
      setAvailableForBookingEventsMap(newMap);
    };
    $[2] = getEventsAvailableForBookingQuery.data?.events;
    $[3] = setAvailableForBookingEventsMap;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== getEventsAvailableForBookingQuery.data || $[6] !== setAvailableForBookingEventsMap) {
    t3 = [getEventsAvailableForBookingQuery.data, setAvailableForBookingEventsMap];
    $[5] = getEventsAvailableForBookingQuery.data;
    $[6] = setAvailableForBookingEventsMap;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== getEventsAvailableForBookingQuery.isLoading) {
    t4 = {
      isLoading: getEventsAvailableForBookingQuery.isLoading
    };
    $[8] = getEventsAvailableForBookingQuery.isLoading;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}